interface MaxContainerProps {
  children: React.ReactNode;
  className?: string;
}

const MaxContainer: React.FC<MaxContainerProps> = ({ children, className }) => {
  return (
    <div className={`max-w-screen-2xl mx-auto px-4 md:px-10 ${className}`}>
      {children}
    </div>
  );
};

export default MaxContainer;
